// API 配置
export const API_CONFIG = {
  // 环境配置
  ENV: process.env.NODE_ENV || 'development',

  // 域名配置
  DOMAINS: {
    production: 'https://api.ipin.work',
    development: 'https://api.ipin.work',
  },

  // 获取当前域名
  getBaseURL(): string {
    const baseUrl = this.DOMAINS[this.ENV as keyof typeof this.DOMAINS] || this.DOMAINS.development;
    return `${baseUrl}/api`;
  },

  // API 接口地址
  ENDPOINTS: {
    // 认证相关
    AUTH: {
      CAPTCHA: '/auth/captcha',
      SEND_CODE: '/auth/send-code',
      LOGIN: '/auth/login',
      PASSWORD_LOGIN: '/auth/password-login',
      PASSWORD_RESET: '/auth/password/reset',
      LOGOUT: '/auth/logout',
      VERIFY_TOKEN: '/auth/me',
    },

    // 用户管理相关
    ACCOUNT: {
      LIST: '/account',
      DETAIL: '/account/detail/:id',
      UPDATE: '/account/:id',
      CREATE: '/account',
      ROLES_LIST: '/account/roles-list',
    },

    // 登录记录相关
    LOGIN_RECORD: {
      LIST: '/account/login-records',
      KICKOUT: '/login-records/:id/kickout',
    },

    // Token管理相关
    TOKEN: {
      // 配置管理
      CONFIGS: '/tokens/configs',
      CONFIG_DETAIL: '/tokens/configs/:id',
      // 用户Token操作
      MY_BALANCE: '/tokens/client/my-balance',
      MY_LOGS: '/tokens/client/my-logs',
      CONSUME: '/tokens/client/consume',
      // 管理员操作
      USER_TOKEN: '/tokens/account/:accountId',
      USER_TOKEN_LOGS: '/tokens/logs',
      USER_OPERATION: '/tokens/account/:accountId/operation',
    },

    // 任务管理相关
    TASK: {
      TYPE_LIST: '/tasks/type-list',
    },

    // 字典管理相关
    DICT: {
      LIST: '/dicts',
      CREATE: '/dicts',
      DETAIL: '/dicts/:id',
      UPDATE: '/dicts/:id',
      DELETE: '/dicts/:id',
      FIND_BY_TYPE: '/dicts/type/:dictType',
      GET_VALUE: '/dicts/value/:dictType',
      SET_VALUE: '/dicts/set-value',
    },

    // 组织管理相关
    ORG: {
      LIST: '/orgs',
      CREATE: '/orgs',
      DETAIL: '/orgs/:id',
      UPDATE: '/orgs/:id',
      DELETE: '/orgs/:id',
      RESTORE: '/orgs/:id/restore',
    },
  },

  // 请求配置
  REQUEST_CONFIG: {
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
    },
  },
};

// 构建完整的 API URL
export const buildApiUrl = (endpoint: string, params?: Record<string, string>): string => {
  let url = API_CONFIG.getBaseURL() + endpoint;

  if (params) {
    Object.keys(params).forEach(key => {
      url = url.replace(`:${key}`, params[key]);
    });
  }

  return url;
};
